import Image from 'global/Image';
import Link from 'next/link';
import {
  SectionWrapper,
  FeaturesWrapper,
  FeatureItemWrapper,
  FeatureItemTitle,
  FeatureDescription,
  Title,
  Description,
  TitleWrapper,
} from './styled';

interface SectionContentProps {
  title: string;
  label: string;
  icon: string;
  url: string;
  features: Array<{
    title: string;
    description: string;
  }>;
  [key: string]: any;
}

function SectionContent({
  title,
  label,
  icon,
  url,
  features,
  ...props
}: SectionContentProps) {
  return (
    <SectionWrapper {...props}>
      <TitleWrapper>
        <Title>{label}</Title>
        <Link href={url} passHref>
          <Description>
            Selengkapnya tentang &nbsp; <b>{title}</b>
          </Description>
        </Link>
        <Image src={icon} alt={title} style={{ width: '50px' }} />
      </TitleWrapper>
      <FeaturesWrapper>
        {features.map((feature) => (
          <FeatureItemWrapper key={feature.title}>
            <FeatureItemTitle>{feature.title}</FeatureItemTitle>
            <FeatureDescription>{feature.description}</FeatureDescription>
          </FeatureItemWrapper>
        ))}
      </FeaturesWrapper>
    </SectionWrapper>
  );
}

export default SectionContent;
